import React, { useState, useRef, useEffect } from 'react';
import './FaqItem.css';


const FaqItem = ({ question, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [maxHeight, setMaxHeight] = useState(defaultOpen ? 'none' : '0px');
  const bodyRef = useRef(null);

  useEffect(() => {
    if (!bodyRef.current) return;
    if (open) {
      const h = bodyRef.current.scrollHeight;
      setMaxHeight(h + 'px');
    } else {
      setMaxHeight('0px');
    }
  }, [open]);

  return (
    <div className={`faq-item ${open ? 'faq-item-open' : ''}`}>
      <button
        type="button"
        className="faq-item-question"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className="faq-item-q-text">{question}</span>
        <span className="faq-item-icon" aria-hidden="true">
          <span className="faq-item-icon-bar faq-item-icon-bar-h" />
          <span className="faq-item-icon-bar faq-item-icon-bar-v" />
        </span>
      </button>
      <div
        className="faq-item-body"
        ref={bodyRef}
        style={{ maxHeight }}
        aria-hidden={!open}
      >
        <div className="faq-item-body-inner">{children}</div>
      </div>
    </div>
  );
};

export default FaqItem;
